<template>
  <div class="explorer-filters-display-container">
    <div class="dmf-container">
      <DismissibleRow
        label="DIMENSIONS"
        :parameters="dimensions"
        @add="handleAdd('dimensions')"
        @click="handleAdd('dimensions')"
        @dismiss="handleParameterDismiss('dimensions', $event)"
      ></DismissibleRow>
      <DismissibleRow
        label="METRICS"
        :parameters="metrics"
        @add="handleAdd('metrics')"
        @click="handleAdd('metrics')"
        @dismiss="handleParameterDismiss('metrics', $event)"
      ></DismissibleRow>
      <FilterRow
        label="FILTERS"
        :displayLimit="2"
        @add="handleAdd"
        @complete="$emit('clearReport')"
      ></FilterRow>
    </div>
    <DashboardCalendarPicker
      id="explorer-calendar"
      :value="localDateValue"
      :minDate="minDate"
      :maxDate="maxDate"
      @click="handleDateApply"
    ></DashboardCalendarPicker>
  </div>
</template>
<script>
import DashboardCalendarPicker from '../Common/DashboardCalendarPicker.vue';
import FilterRow from '../Common/FilterRow.vue';
import DismissibleRow from '../Common/DismissibleRow.vue';

export default {
  props: {
    dimensions: {
      type: Array,
    },
    metrics: {
      type: Array,
    },
    filters: {
      type: Array,
    },
    dateValue: {
      type: Object,
    },
    minDate: {
      type: [Date, Number],
    },
    maxDate: {
      type: [Date, Number],
    },
    portfolioBrands: {
      type: Array,
    },
  },
  components: {
    DashboardCalendarPicker,
    DismissibleRow,
    FilterRow,
  },
  data() {
    return {
      localDateValue: this.dateValue,
    };
  },
  methods: {
    handleAdd(label) {
      this.$emit('add', label);
    },
    handleDateApply(value) {
      this.$emit('dateApply', value);
    },
    handleParameterDismiss(label, parameter) {
      this.$emit('dismiss', { label, parameter });
    },
  },
  watch: {
    dateValue() {
      this.localDateValue = this.dateValue;
    },
  },
};
</script>
<style scoped>
.explorer-filters-display-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  background-color: #FFFFFF;
  border-radius: 4px;
  width: calc(100% - 32px);
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.4);
  margin-top: 16px;
  padding: 16px;
}

.explorer-filters-display-container::after {
  content: "";
  position: absolute;
  overflow: hidden;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid #FFFFFF;
  top: -9px;
  left: calc(100% - 32px);
  filter: drop-shadow(0px -1px 0.75px rgba(0, 0, 0, 0.4));
}

.dmf-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: calc(100% - 350px);
  gap: 16px;
}

.dmf-container .report-field-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.calendar-picker-container {
  z-index: 2;
}

#explorer-calendar {
  width: 300px;
  height: 65%;
}
</style>
<style>
.explorer-filters-display-container .picker-container {
  right: 0;
}
</style>
